export default __webpack_public_path__ + "static/light-testimonial-bg-desktop-975078fb756f1f2b997595f70aacf465.png";